import {RouteView, PageView} from '../layouts'

export const directSeeding = {
  path: '/directSeeding',
  redirect: '/directSeeding/index',
  meta: { title: '直播管理', icon: 'code', isMenuShow:true, permission: 'live'},
  component:PageView,
  children: [
    {
      path: '/directSeeding/index',
      name: 'directSeeding',
      component: () => import('../views/directSeeding/index.vue'),
      meta: {title: '直播间设置', icon: 'dollar', isMenuShow: true, permission: 'live:set'},
    },
    {
      path: '/directSeeding/control',
      name: 'control',
      component: () => import('../views/directSeeding/control.vue'),
      meta: {title: '直播控制台', icon: 'dollar', isMenuShow: true, permission: 'live:control'},
    },
    {
      path: '/directSeeding/shopMsg',
      name: 'shopMsg',
      component: () => import('../views/directSeeding/shopMsg.vue'),
      meta: {title: '商品信息', icon: 'dollar', isMenuShow: true, permission: 'live:goods'},
    }
  ]
}
